export const getWholeNumberOrTwoDecimal = (value: number | undefined): number => {
  if (!value || isNaN(value)) {
    return 0;
  }
  if (!(value % 1)) {
    return value;
  }
  return +value.toFixed(2);
};
